import React, { Fragment } from "react"
import { Helmet } from "react-helmet"



//componets
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import TeamTwoA from "../../../components/team/TeamTwoA"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"
import { Link } from "react-router-dom"


const Team = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Nuestro Equipo de Expertos en Tecnología</title>
                    <meta name="description" content="Conoce al equipo de profesionales de CuySoft. Expertos en desarrollo de software, ciberseguridad e innovación tecnológica en Ecuador." />
                    <meta name="keywords" content="equipo CuySoft, profesionales tecnología Ecuador, expertos desarrollo software, equipo ciberseguridad" />
                    <link rel="canonical" href="https://www.cuysoft.com/team" />
                    <meta property="og:title" content="Equipo de Expertos – CuySoft Ecuador" />
                    <meta property="og:description" content="Profesionales expertos en tecnología, desarrollo de software y ciberseguridad." />
                    <meta property="og:url" content="https://www.cuysoft.com/team" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Equipo" />
                {/* PageTitle */}

                {/*cuysoft-team start*/}
                <section className="cuysoft-team team-sec-two mt-0 pt-145 pb-145 pt-lg-55 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb-55">
                                    <h6 className="sub-title mb-20">Nuestro Equipo</h6>
                                    <h2 className="sect-title">Miembros Expertos del Equipo</h2>
                                </div>
                            </div>
                        </div>
                        {/* TeamTwoA start*/}
                        <TeamTwoA />
                        {/* TeamTwoA end */}
                        <div className="row gx-4 gx-xxl-5">
                            <div className="col-lg-12 text-center pt-15" data-aos="fade-up" data-aos-delay={200}>
                                <Link className="theme_btn" to="/team">Ver Todo el Equipo</Link>
                            </div>
                        </div>
                    </div>
                </section>
                {/*cuysoft-team end*/}

                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                <FooterThree />

            </div>

        </Fragment>
    )
}

export default Team